module.exports = __webpack_public_path__ + "static/media/gen_img03.fe5c1772.png";